module.exports = __webpack_public_path__ + "img/pre-banner-centre.0d495550.svg";